import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon, TrophyIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const BASE_URL = 'https://italia.kitonline.shop/cart/44692291485831:1';
const ELITE_URL = 'https://italia.kitonline.shop/cart/44692510212231:1';
export function PricingCard() {
  return <section id="pricing" className="py-10 sm:py-14 px-4 relative scroll-mt-10" data-id="element-210">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-211" />

      <div className="max-w-md sm:max-w-lg mx-auto relative z-10" data-id="element-212">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-8 text-brand-cream" data-id="element-213">
          Scegli il tuo <span className="text-brand-orange" data-id="element-214">Piano</span>
        </motion.h2>

        {/* SISTEMA BASE */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#1a0f0a] to-[#120a06] border border-brand-orange/40 rounded-3xl relative shadow-[0_0_50px_rgba(249,115,22,0.15)] mb-10" data-id="element-215">
          <div className="flex justify-center -mt-4 mb-2" data-id="element-216">
            <div className="bg-gradient-to-b from-brand-gold to-amber-500 text-black font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-[0_0_20px_rgba(251,191,36,0.5)]" data-id="element-217">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-218" />
              LA SCELTA PIÙ POPOLARE
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-219">
            <h3 className="text-xl font-black text-center text-brand-cream uppercase mb-1" data-id="element-220">
              ⭐ Sistema Base
            </h3>
            <p className="text-center text-xs text-gray-400 mb-5" data-id="element-221">
              Tutto il necessario per iniziare
            </p>

            <div className="space-y-0 mb-5" data-id="element-222">
              {[{
              label: '6 Tomi Tecnici (800+ pagine)',
              price: '€ 97'
            }, {
              label: 'Slide per la LIM e Materiale Digitale',
              price: '€ 57'
            }, {
              label: 'Manuali Schemi Elettrici Pronti',
              price: '€ 47'
            }, {
              label: '4 Bonus Esclusivi',
              price: '€ 49'
            }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-white/10 py-3 gap-3" data-id="element-223">
                  <span className="text-gray-300 font-medium text-sm" data-id="element-224">
                    {item.label}
                  </span>
                  <span className="text-gray-500 line-through text-sm shrink-0" data-id="element-225">
                    {item.price}
                  </span>
                </div>)}
              <div className="flex justify-between items-center pt-4" data-id="element-226">
                <span className="text-base font-black text-brand-cream uppercase" data-id="element-227">
                  VALORE REALE:
                </span>
                <span className="text-xl font-black text-brand-danger line-through" data-id="element-228">
                  € 250
                </span>
              </div>
            </div>

            <div className="bg-[#1f110a] border border-brand-orange/40 rounded-2xl p-5 text-center mb-5" data-id="element-229">
              <div className="inline-block bg-brand-danger/20 border border-brand-danger/40 text-brand-danger text-[11px] font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-230">
                89% di sconto
              </div>
              <p className="text-gray-500 line-through text-base mb-1" data-id="element-231">€ 250</p>
              <div className="flex justify-center items-end gap-1 mb-1" data-id="element-232">
                <span className="text-4xl sm:text-5xl font-black text-brand-orange leading-none" data-id="element-233">
                  € 27,90
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-2" data-id="element-234">
                💳 Pagamento unico • ⚡ Accesso immediato
              </p>
            </div>

            <div className="flex justify-center mb-5" data-id="element-235">
              <div className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full" data-id="element-236">
                <ShieldCheckIcon className="w-4 h-4 text-brand-orange" data-id="element-237" />
                <span className="text-xs font-bold text-brand-orange" data-id="element-238">
                  ⏰ Prezzo speciale di lancio — aumenterà a breve
                </span>
              </div>
            </div>

            <CTAButton href={BASE_URL} className="w-full mb-5" data-id="element-239">
              SÌ, VOGLIO IL SISTEMA BASE — € 27,90
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-240">
              <span className="flex items-center gap-1" data-id="element-241">
                <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-242" /> Accesso
                Immediato
              </span>
              <span className="text-gray-600" data-id="element-243">•</span>
              <span className="flex items-center gap-1" data-id="element-244">
                <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-245" /> Garanzia
                7 Giorni
              </span>
              <span className="text-gray-600" data-id="element-246">•</span>
              <span className="flex items-center gap-1" data-id="element-247">
                <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-248" /> Un Solo
                Pagamento
              </span>
            </div>
          </div>
        </motion.div>

        {/* SISTEMA ELITE */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#0a0f1f] to-[#06080f] border-2 border-brand-gold/60 rounded-3xl relative shadow-[0_0_60px_rgba(251,191,36,0.25)]" data-id="element-249">
          <div className="flex justify-center -mt-4 mb-2" data-id="element-250">
            <div className="bg-gradient-to-b from-amber-300 via-brand-gold to-amber-500 text-black font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-[11px] shadow-[0_0_25px_rgba(251,191,36,0.6)]" data-id="element-251">
              <TrophyIcon className="w-3.5 h-3.5 fill-current" data-id="element-252" />
              PER CHI VUOLE L'ECCELLENZA
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-253">
            <h3 className="text-xl font-black text-center text-brand-gold uppercase mb-1" data-id="element-254">
              💎 Sistema Integrale Elite
            </h3>
            <p className="text-center text-xs text-gray-400 mb-5" data-id="element-255">
              Senza compromessi
            </p>

            <div className="space-y-0 mb-5" data-id="element-256">
              {[{
              label: '✅ Tutto il contenuto del Sistema Base',
              price: '€ 250',
              strike: true
            }, {
              label: '➕ Archivio Smart Home Pro ELITE',
              price: '€ 120',
              strike: true
            }, {
              label: 'Building Automation Industriale',
              price: 'incluso',
              strike: false
            }, {
              label: 'Digital Twin e IA Applicata al BAS',
              price: 'incluso',
              strike: false
            }, {
              label: 'Casi Studio di Eccellenza Europei',
              price: 'incluso',
              strike: false
            }, {
              label: 'Troubleshooting Sistemi Complessi',
              price: 'incluso',
              strike: false
            }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-white/10 py-3 gap-3" data-id="element-257">
                  <span className="text-gray-300 font-medium text-sm" data-id="element-258">
                    {item.label}
                  </span>
                  <span className={`text-sm shrink-0 ${item.strike ? 'text-gray-500 line-through' : 'text-brand-gold font-bold uppercase text-xs'}`} data-id="element-259">
                    {item.price}
                  </span>
                </div>)}
              <div className="flex justify-between items-center pt-4" data-id="element-260">
                <span className="text-base font-black text-brand-cream uppercase" data-id="element-261">
                  VALORE REALE:
                </span>
                <span className="text-xl font-black text-brand-danger line-through" data-id="element-262">
                  € 370
                </span>
              </div>
            </div>

            <div className="bg-[#0f1422] border border-brand-gold/40 rounded-2xl p-5 text-center mb-5" data-id="element-263">
              <div className="inline-block bg-brand-gold/20 border border-brand-gold/40 text-brand-gold text-[11px] font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-264">
                90% di sconto
              </div>
              <p className="text-gray-500 line-through text-base mb-1" data-id="element-265">€ 370</p>
              <div className="flex justify-center items-end gap-1 mb-1" data-id="element-266">
                <span className="text-4xl sm:text-5xl font-black text-brand-gold leading-none" data-id="element-267">
                  € 37,90
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-2" data-id="element-268">
                💳 Pagamento unico • ⚡ Accesso immediato
              </p>
            </div>

            <p className="text-center text-xs text-brand-gold/80 font-bold mb-5 leading-snug" data-id="element-269">
              🏆 L'opzione definitiva per System Integrator, ITS Academy e
              Professionisti Senior
            </p>

            <a href={ELITE_URL} className="relative inline-flex items-center justify-center w-full px-5 py-4 sm:px-6 sm:py-5 bg-gradient-to-r from-brand-gold via-amber-400 to-brand-gold text-black font-black text-base sm:text-lg uppercase tracking-wide rounded-2xl shadow-[0_0_30px_rgba(251,191,36,0.55)] hover:shadow-[0_0_40px_rgba(251,191,36,0.75)] hover:scale-[1.01] transition-all duration-300 mb-5 border border-amber-200/30" data-id="element-270">
              <span className="relative z-10 flex items-center justify-center gap-2 leading-tight text-center" data-id="element-271">
                <span className="text-xl" data-id="element-272">🏆</span>
                <span data-id="element-273">SÌ, VOGLIO IL SISTEMA ELITE — € 37,90</span>
              </span>
            </a>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-274">
              <span className="flex items-center gap-1" data-id="element-275">
                <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-276" /> Accesso
                Immediato
              </span>
              <span className="text-gray-600" data-id="element-277">•</span>
              <span className="flex items-center gap-1" data-id="element-278">
                <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-279" /> Garanzia
                7 Giorni
              </span>
              <span className="text-gray-600" data-id="element-280">•</span>
              <span className="flex items-center gap-1" data-id="element-281">
                <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-282" /> Un Solo
                Pagamento
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}